// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Upload_wrapper__2vSTN","file_wrapper":"Upload_file_wrapper__NB4H5"};